class BoardCast {
  callback_method_collect = {

  }

  on(event, cb) {
    if(event) {
      if(typeof cb === 'function') {
        if(!this.callback_method_collect[event]) {
          this.callback_method_collect[event] = {};
        }
        this.callback_method_collect[event][cb.toString()] = cb;
      }
    }
  }

  emit(event) {
    if(typeof this.callback_method_collect[event] === 'object') {
      for(let cb_key in this.callback_method_collect[event]) {
        this.callback_method_collect[event][cb_key]();
      }
    }
  }
}

let board_cast = new BoardCast();
export default board_cast;



// WEBPACK FOOTER //
// ./src/common/BoardCast.js